import "@/styles/globals.css";
import Head from "next/head";
import { Toaster } from "react-hot-toast";
import PanelThemeSync from "@/components/PanelThemeSync";
import PanelI18nRoot from "@/components/PanelI18nRoot";
import DefaultSeo from "@/components/seo/DefaultSeo";
import { AdminAuthProvider } from "@/contexts/AdminAuthContext";
import { AgentAuthProvider } from "@/contexts/AgentAuthContext";
import { UserAuthProvider } from "@/contexts/UserAuthContext";
import MaintenanceGate from "@/components/MaintenanceGate";

export default function App({ Component, pageProps }) {
  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>
      <DefaultSeo />
      <PanelThemeSync />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "var(--bg-card)",
            color: "var(--text-primary)",
            border: "1px solid var(--border)",
          },
        }}
      />
      <AdminAuthProvider>
        <PanelI18nRoot>
          <UserAuthProvider>
            <AgentAuthProvider>
              <MaintenanceGate>
                <Component {...pageProps} />
              </MaintenanceGate>
            </AgentAuthProvider>
          </UserAuthProvider>
        </PanelI18nRoot>
      </AdminAuthProvider>
    </>
  );
}
